import { fetchApi } from './fetchApi';

// utils/urlBase64ToUint8Array.ts
export function urlBase64ToUint8Array(base64String: string) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

export async function registerPush(publicVapidKey: string) {
  if (!('serviceWorker' in navigator)) throw new Error('No SW support!');
  if (!('PushManager' in window)) throw new Error('No Push API support!');

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('Permission denied');

  const reg = await navigator.serviceWorker.register('/service-worker.js');
  const subscription = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicVapidKey)
  });

  try {
    await fetchApi('notification_subscribe', {
      subscription_obj: JSON.stringify(subscription),
    });
  } catch (error) {
    console.log('Notification subscribe error:', String(error));
  }

  return subscription;
}

export async function getCurrentSubscription(): Promise<PushSubscription | null> {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return null;
  try {
    const reg = await navigator.serviceWorker.ready;
    return await reg.pushManager.getSubscription();
  } catch {
    return null;
  }
}

export function isNotifEnabledFrom(sub: PushSubscription | null): boolean {
  return !!sub && Notification.permission === 'granted';
}
